import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';

import { Typography } from '@material-ui/core';

import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import ConfirmContext from 'contexts/ConfirmContext';

import BookingInformation from '../booking-information/BookingInformation';

import { currencyFormatter } from 'utils/prices/formatter';
import {
  getSummeryPriceForActivitySeveralDays,
  getTotalPrice
} from 'utils/book-accommodation-and-activity/totalPrice';

import { PLURAL_PARTICIPANTS } from 'constants/participants';

import { LOCALES_OBJ } from 'constants/base';

import { getFormByCurrentLanguage } from 'utils/form-localization/formLocalization';

import useStyles from './styles';
import Widget from 'pages/widget/Widget';

const FIXED_PRICES = 'pricesFixedForm';
const CATEGORY_PRICES = 'pricesCategoryForm';
const DAILY_PRICES = 'pricesDailyForm';
const FUTURE_PRICES = 'futurePricesForm';

const getTotalParticipantPrice = (
  pricesType,
  price,
  amount,
  dates,
  isAccommodation
) => {
  let totalPrice;
  if (isAccommodation && pricesType === DAILY_PRICES) {
    totalPrice = price;
  } else if ((pricesType === FIXED_PRICES && isAccommodation) 
    || (pricesType === FUTURE_PRICES && isAccommodation) 
    || pricesType === CATEGORY_PRICES) {
    if (dates && dates.startDate && dates.endDate) {
      const participants = pricesType === CATEGORY_PRICES ? amount : 1;
      const nights = dates.endDate.diff(dates.startDate, 'days');
      totalPrice = parseInt(nights) * price * participants;
      

    } else {


      totalPrice = price;
    }
  } else if (pricesType === FIXED_PRICES && !isAccommodation) {
    totalPrice = price;
  } else {
    totalPrice = price * amount;
  }
  if (!isAccommodation) {
    totalPrice = getSummeryPriceForActivitySeveralDays(dates, totalPrice);
  }

  return currencyFormatter(totalPrice);
};

const Participants = ({
  participants,
  pricesType,
  dates,
  currency,
  productsMenuIndex,
  isAccommodation
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const startDate = dates && dates.startDate;
  const endDate = dates && dates.endDate;
  const diffTime = Math.abs(endDate - startDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const pluralNigts = diffDays > 1 ? t('nights') : t('night');

  return (
    <div>
      {participants.map((item, index) => {
        if (!item.participants || !parseInt(item.participants)) return;
        const amount = parseInt(item.participants);
        const price = currencyFormatter(item[currency]);
        const totalPrice = getTotalParticipantPrice(
          pricesType,
          item[currency],
          amount,
          dates,
          isAccommodation
        );


        return (
          <div
            key={index}
            className={classNames(classes.generalRow, classes.participantRow)}
          >
            {isAccommodation && pricesType === DAILY_PRICES ? (
              <Typography variant="body1" className={classes.bookingColumn}>
                {amount}{' '}
                {amount > 1
                  ? t(PLURAL_PARTICIPANTS[item.participant] || 'guests')
                  : t(item.participant) || 'guest'}{' '}
                {diffDays ? '× ' + diffDays + '  ' + pluralNigts : ''}
              </Typography>
            ) : (
              <>
                {pricesType === 'pricesFixedForm' || pricesType === 'futurePricesForm' ? (
                  <Typography variant="body1" className={classes.bookingColumn}>
                    <span className={classes.currency}>{currency}</span> {price}{' '}
                    {diffDays
                      ? t('per night') + ' × ' + diffDays + ' ' + pluralNigts
                      : ''}
                  </Typography>
                ) : (
                  <Typography variant="body1" className={classes.bookingColumn}>
                    <span className={classes.currency}>{currency}</span> {price}{' '}
                    {diffDays ? t('per night') : ''} × {amount}{' '}
                    {amount > 1
                      ? t(PLURAL_PARTICIPANTS[item.participant] || 'guests')
                      : t(item.participant) || 'guest'}{' '}
                    {diffDays ? '× ' + diffDays + '  ' + pluralNigts : ''}
                  </Typography>
                )}
              </>
            )}

            <Typography variant="h3" className={classes.bookingColumn}>
              <span className={classes.currency}>{currency}</span> {totalPrice}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

const AddOns = ({
  addOns,
  currency,
  changeFormFieldValue,
  isRelated,
  products,
  isStatic
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  const confirm = React.useContext(ConfirmContext);

  const selectedLanguage = i18n.language;

  const isAddOns = !!addOns.filter(item => item.value && parseInt(item.value))
    .length;

  const deleteAddOn = deletedAddOn => {
    confirm({
      title: 'Are you sure you want to delete it?',
      confirmationText: 'Delete',
      cancellationText: 'Back'
    })
      .then(() => {
        if (isRelated) {
          const productIndex = deletedAddOn.productIndex;
          const index = deletedAddOn.index;
          // changeFormFieldValue(
          //   `activities[${index}].addOns`,
          //   products[index].addOns.filter(item => item.id !== deletedAddOn.id)
          // );

          changeFormFieldValue(`activities[${productIndex}].addOns[${index}]`, {
            ...deletedAddOn,
            value: 0
          });

          return;
        }

        changeFormFieldValue(
          'addOns',
          addOns.filter(item => item !== deletedAddOn)
        );
      })
      .catch(() => { });
  };

  if (!isAddOns) return null;

  return (
    <div className={classes.accommodationCheckout}>
      <Typography
        variant="h4"
        classes={{ root: classNames(classes.generalRow, classes.listTitle) }}
      >
        {t('Add-ons')}
      </Typography>

      {addOns.map((item, index) => {
        if (!item.value || !parseInt(item.value)) return;
        const form = getFormByCurrentLanguage(
          selectedLanguage,
          item,
          item['Norwegian']
        );
        const amount = item.value;
        const price = currencyFormatter(item[currency]);
        const totalPrice = currencyFormatter(item[currency] * amount);
        return (
          <div key={index} className={classes.checkoutInfo}>
            <div className={classes.generalRow}>
              <Typography variant="h3" className={classes.bookingTitle}>
                {form.title}
              </Typography>
              {!isStatic && (
                <DeleteOutlineIcon
                  className={classes.deleteIcon}
                  onClick={() => deleteAddOn(item)}
                />
              )}
            </div>
            <div className={classes.generalRow}>
              <Typography variant="body1">
                <span className={classes.currency}>{currency}</span> {price} ×{' '}
                {amount}
              </Typography>
              <Typography variant="h3">
                <span className={classes.currency}>{currency}</span>{' '}
                {totalPrice}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const MandatoryFees = ({
  mandatoryFees = [],
  currency,
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  const selectedLanguage = i18n.language;

  const isMandatoryFees = Array.isArray(mandatoryFees) && mandatoryFees.some(
    item => item[currency] && parseFloat(item[currency])
  );



  if (!isMandatoryFees) return null;

  return (
    <div className={classes.accommodationCheckout}>
      <Typography
        variant="h4"
        classes={{ root: classNames(classes.generalRow, classes.listTitle) }}
      >
        {t('Mandatory-Fee')}
      </Typography>

      {mandatoryFees.map((item, index) => {
        if (!item[currency] || !parseInt(item[currency])) return;
        const form = getFormByCurrentLanguage(
          selectedLanguage,
          item,
          item['Norwegian']
        );
        const price = currencyFormatter(item[currency])
        return (
          <div key={index} className={classes.checkoutInfo}>
            <div className={classes.generalRow}>
              <Typography variant="h3" className={classes.bookingTitle}>
                {form.title}
              </Typography>
            </div>
            <div className={classes.generalRow}>
              <Typography variant="body1">
                <span className={classes.currency}>{currency}</span>

              </Typography>

              <Typography variant="h3">
                <span className={classes.currency}>{currency}{' '}</span>
                {price}
              </Typography>

            </div>
          </div>
        );
      })}
    </div>
  );
};

export const GeneralCheckout = ({
  changeFormFieldValue,
  widgetForm,
  productData,
  currency,
  isAccommodationBooking,
  isStatic,
  productsMenuIndex
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  const values = widgetForm.values;
  const generalForm = productData.generalForm;
  const generalFormNorwegian = productData['generalForm-Norwegian'];
  const pricesType = productData.pricesType;

  let dates = values.dates;
  const startingDate =
    values.startingDate &&
    moment(values.startingDate)
      .locale(LOCALES_OBJ[selectedLanguage])
      .format('MMM DD, YYYY');
  const endingDate =
    values.endingDate &&
    moment(values.endingDate)
      .locale(LOCALES_OBJ[selectedLanguage])
      .format('MMM DD, YYYY');
  const startTime = values.startTime ? values.startTime.startTime : null;
  const timeType = values.startTime ? values.startTime.timeType : null;
  const duration = values.startTime ? values.startTime.duration : null;
  const startDate =
    dates &&
    moment(dates.startDate)
      .locale(LOCALES_OBJ[selectedLanguage])
      .format('MMM DD, YYYY');
  const endDate =
    dates &&
    moment(dates.endDate)
      .locale(LOCALES_OBJ[selectedLanguage])
      .format('MMM DD, YYYY');
  const checkIn =
    generalForm.checkInAfter && moment(generalForm.checkInAfter).format('H:mm');
  const checkOut =
    generalForm.checkOutBefore &&
    moment(generalForm.checkOutBefore).format('H:mm');

  const participants = values.participants;
  const addOns = values.addOns;
  // const mandatoryFees = values.accommodations[0]?.mandatoryFees ;
  const mandatoryFees = values.mandatoryFees;

  let isAccommodation = !productData.scheduleType;

  if (isStatic && !dates && startingDate && endingDate) {
    isAccommodation = false;
    dates = {
      startDate: values.startingDate,
      endDate: values.endingDate
    };
  }

  if (isStatic && values.multiDates && values.multiDates.endDate) {
    isAccommodation = false;
    dates = {
      startDate: values.multiDates.startDate,
      endDate: values.multiDates.endDate
    };
  }

  return (
    <>
      <div className={classes.accommodationCheckout}>
        <Typography
          variant="h4"
          classes={{ root: classNames(classes.generalRow, classes.listTitle) }}
        >
          {isAccommodationBooking ? t('Accommodation') : t('Activity')}
        </Typography>
        <div className={classes.checkoutInfo}>
          <div className={classes.generalRow}>
            <Typography variant="h3" className={classes.bookingTitle}>
              {
                getFormByCurrentLanguage(
                  selectedLanguage,
                  generalForm,
                  generalFormNorwegian
                ).title
              }
            </Typography>
          </div>
          <div className={classes.generalRow}>
            {startingDate && !endingDate && (
              <Typography variant="body1">
                {startingDate}{' '}
                {startTime && `· ${startTime} · ${duration} ${t(timeType)}`}
              </Typography>
            )}
            {startingDate && endingDate && (
              <Typography variant="body1">
                {startingDate} {' - '} {endingDate}
              </Typography>
            )}
            {startDate && (
              <Typography variant="body1">
                {startDate} – {endDate}
              </Typography>
            )}
          </div>
          {checkIn && (
            <div className={classes.generalRow}>
              <Typography variant="body1">
                {t('Check-in')}: {checkIn} - {t('Check-out')}: {checkOut}
              </Typography>
            </div>
          )}
        </div>
        <Participants
          participants={participants}
          pricesType={pricesType}
          dates={dates}
          currency={currency}
          productsMenuIndex={productsMenuIndex}
          isAccommodation={isAccommodation}
        />
      </div>
      <MandatoryFees
        mandatoryFees={mandatoryFees}
        currency={currency}
        changeFormFieldValue={changeFormFieldValue}
        isStatic={isStatic}
      />
      <AddOns
        addOns={addOns}
        currency={currency}
        changeFormFieldValue={changeFormFieldValue}
        isStatic={isStatic}
      />
    </>
  );
};

export const RelatedCheckout = ({
  changeFormFieldValue,
  widgetForm,
  currency,
  isAccommodationBooking,
  isStatic,
  productsMenuIndex
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  const confirm = React.useContext(ConfirmContext);

  const selectedLanguage = i18n.language;

  const activities = widgetForm.values.activities;
  const selectedActivities = activities.filter(item => item.isSelected);

  let addOns = [];
  let mandatoryFees = [];

  activities.map((item, activityIndex) => {
    if (!item.isSelected || !item.addOns) return false;
    const _addOns = item.addOns.map((item, index) => {
      item.productIndex = activityIndex;
      item.index = index;
      return item;
    });
    addOns = [...addOns, ..._addOns];
  });

  activities.map((item, activityIndex) => {
    if (!item.isSelected || !item.mandatoryFees) return false;
    const _mandatoryFees = item.mandatoryFees.map((item, index) => {
      item.productIndex = activityIndex;
      item.index = index;
      return item;
    });
    mandatoryFees = [...mandatoryFees, ..._mandatoryFees];
  });

  const deleteRelatedProduct = deletedProductIndex => {
    confirm({
      title: 'Are you sure you want to delete it?',
      confirmationText: 'Delete',
      cancellationText: 'Back'
    })
      .then(() => {
        changeFormFieldValue(
          'activities',
          activities.map((item, index) => {
            if (index === deletedProductIndex) {
              return {
                ...item,
                isSelected: false
              };
            }
            return item;
          })
        );
      })
      .catch(() => { });
  };

  if (!selectedActivities.length) return null;

  return (
    <>
      <div className={classes.accommodationCheckout}>
        <Typography
          variant="h4"
          classes={{ root: classNames(classes.generalRow, classes.listTitle) }}
        >
          {isAccommodationBooking ? t('Activities') : t('Accommodations')}
        </Typography>

        <div>
          {activities.map((item, index) => {
            if (!item.isSelected) return;
            const form = getFormByCurrentLanguage(
              selectedLanguage,
              item,
              item['Norwegian']
            );
            const startingDate = item.startingDate
              ? moment(item.startingDate)
                .locale(LOCALES_OBJ[selectedLanguage])
                .format('MMM DD, YYYY')
              : '';
            const endingDate = item.endingDate
              ? moment(item.endingDate)
                .locale(LOCALES_OBJ[selectedLanguage])
                .format('MMM DD, YYYY')
              : '';
            const startTime = item.startTime ? item.startTime.startTime : null;
            const timeType = item.startTime ? item.startTime.timeType : null;
            const duration = item.startTime ? item.startTime.duration : null;
            let dates = item.dates;
            const startDate =
              dates &&
              moment(dates.startDate)
                .locale(LOCALES_OBJ[selectedLanguage])
                .format('MMM DD, YYYY');
            const endDate =
              dates &&
              moment(dates.endDate)
                .locale(LOCALES_OBJ[selectedLanguage])
                .format('MMM DD, YYYY');
            const checkIn =
              item.checkInAfter && moment(item.checkInAfter).format('H:mm');
            const checkOut =
              item.checkOutBefore && moment(item.checkOutBefore).format('H:mm');
            const participants = item.participants;
            const pricesType = item.pricesType;

            let isAccommodation = !item.scheduleType;

            if (isStatic && !dates && startingDate && endingDate) {
              isAccommodation = false;
              dates = {
                startDate: item.startingDate,
                endDate: item.endingDate
              };
            }

            if (isStatic && item.multiDates && item.multiDates.endDate) {
              isAccommodation = false;
              dates = {
                startDate: item.multiDates.startDate,
                endDate: item.multiDates.endDate
              };
            }

            return (
              <div key={index}>
                <div className={classes.checkoutInfo}>
                  <div className={classes.generalRow}>
                    <Typography variant="h3" className={classes.bookingTitle}>
                      {form.title}
                    </Typography>
                    {!isStatic && (
                      <DeleteOutlineIcon
                        className={classes.deleteIcon}
                        onClick={() => deleteRelatedProduct(index)}
                      />
                    )}
                  </div>
                  <div className={classes.generalRow}>
                    {startingDate && !endingDate && (
                      <Typography variant="body1">
                        {startingDate}{' '}
                        {startTime &&
                          `· ${startTime} · ${duration} ${t(timeType)}`}
                      </Typography>
                    )}
                    {startingDate && endingDate && (
                      <Typography variant="body1">
                        {startingDate} {' - '} {endingDate}
                      </Typography>
                    )}
                    {startDate && (
                      <Typography variant="body1">
                        {startDate} – {endDate}
                      </Typography>
                    )}
                  </div>
                  {checkIn && (
                    <div className={classes.generalRow}>
                      <Typography variant="body1">
                        {t('Check-in')}: {checkIn} - {t('Check-out')}:{' '}
                        {checkOut}
                      </Typography>
                    </div>
                  )}
                </div>
                <div className={classes.checkoutInfo}>
                  <Participants
                    changeFormFieldValue={changeFormFieldValue}
                    isDelete={true}
                    participants={participants}
                    pricesType={pricesType}
                    dates={dates || item.multiDates}
                    currency={currency}
                    productsMenuIndex={productsMenuIndex}
                    isAccommodation={isAccommodation}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <MandatoryFees
        mandatoryFees={mandatoryFees}
        currency={currency}
        changeFormFieldValue={changeFormFieldValue}
        isRelated={true}
        products={activities}
        isStatic={isStatic}
      />
      <AddOns
        addOns={addOns}
        currency={currency}
        changeFormFieldValue={changeFormFieldValue}
        isRelated={true}
        products={activities}
        isStatic={isStatic}
      />
    </>
  );
};

export const Total = ({ widgetForm, productData, currency, isStatic }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  let dates = widgetForm.values.dates;
  const participants = widgetForm.values.participants;
  const addOns = widgetForm.values.addOns;
  const mandatoryFees = widgetForm.values.mandatoryFees;
  const activities = widgetForm.values.activities;
  let selectedActivities = activities.filter(item => item.isSelected);
  const pricesTypeObj = {
    pricesType: productData.pricesType,
    isAccommodation: !productData.scheduleType
  };
  const startingDate = widgetForm.values.startingDate;
  const endingDate = widgetForm.values.endingDate;

  selectedActivities = selectedActivities.map(activity => {
    if (activity.startingDate && activity.endingDate) {
      return {
        ...activity,
        isAccommodation: false,
        multiDates: {
          startDate: activity.startingDate,
          endDate: activity.endingDate
        }
      };
    }
    if (activity.multiDates) {
      return {
        ...activity,
        isAccommodation: false
      };
    }
    return {
      ...activity,
      isAccommodation: true
    };
  });

  if (isStatic && !dates && startingDate && endingDate) {
    dates = {
      startDate: startingDate,
      endDate: endingDate
    };
  }

  if (
    isStatic &&
    !dates &&
    widgetForm.values.multiDates &&
    widgetForm.values.multiDates.endDate
  ) {
    dates = {
      startDate: widgetForm.values.multiDates.startDate,
      endDate: widgetForm.values.multiDates.endDate
    };
  }

  const totalPrice = currencyFormatter(
    getTotalPrice(
      pricesTypeObj,
      dates,
      participants,
      addOns,
      mandatoryFees,
      selectedActivities,
      currency,
      dates
    )
  );

  return (
    <div className={classes.totalRow}>
      <Typography variant="h3" className={classes.bookingTitle}>
        {t('Total')}
      </Typography>
      <Typography variant="h3">
        <span className={classes.currency}>{currency}</span> {totalPrice}
      </Typography>
    </div>
  );
};

const Checkout = ({
  changeFormFieldValue,
  handleSubmit,
  title,
  widgetForm,
  isSummary,
  productData,
  wrapperClass,
  isAccommodationBooking,
  productsMenuIndex
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const currency = widgetForm ? widgetForm.values.currency : '';

  return (
    <div className={classNames(classes.wrapper, wrapperClass)}>
      <div className={classes.leftSide}>
        <Typography variant="h3" classes={{ root: classes.sectionTitleIndent }}>
          {t(title)}
        </Typography>

        <form onSubmit={handleSubmit} className={classes.list}>
          {isSummary && (
            <Typography variant="h3" className={classes.summaryTitle}>
              Summary
            </Typography>
          )}
          <GeneralCheckout
            changeFormFieldValue={changeFormFieldValue}
            widgetForm={widgetForm}
            productData={productData}
            currency={currency}
            isAccommodationBooking={isAccommodationBooking}
            productsMenuIndex={productsMenuIndex}
          />
          <RelatedCheckout
            changeFormFieldValue={changeFormFieldValue}
            widgetForm={widgetForm}
            currency={currency}
            isAccommodationBooking={isAccommodationBooking}
            productsMenuIndex={productsMenuIndex}
          />
          <Total
            widgetForm={widgetForm}
            productData={productData}
            currency={currency}
            isAccommodationBooking={isAccommodationBooking}
          />
        </form>
      </div>
      <div className={classes.rightSide}>
        <BookingInformation data={productData} form={widgetForm} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    widgetForm: state.form.widgetForm
  };
};

const mapDispatchToProps = dispatch => ({
  changeFormFieldValue: (field, value) => {
    dispatch(change('widgetForm', field, value));
  }
});

export default reduxForm({
  form: 'widgetForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false
})(connect(mapStateToProps, mapDispatchToProps)(Checkout));
